import { Profession } from "@teamprevent/common/adminUser/models";

import { AdminUserListModel } from "../adminUser/model";

import { Location } from "redux-little-router";

export const getUserDisplayNameWithTeamAndProfession = (adminUser: AdminUserListModelWithTeams) => {
    if (!adminUser) {
        return "";
    }

    let displayName = adminUser.emailAddress;

    if (adminUser.teams?.length) {

        const teams = adminUser.teams.join(", ");

        if (teams) {
            displayName += ` (${teams})`;
        }
    }

    if (adminUser.profession) {
        displayName += ` (${adminUser.profession})`;
    }

    return displayName;
};

export interface AdminUserListModelWithTeams extends AdminUserListModel {
    readonly teams?: string[];
    readonly profession?: Profession;
}

export interface AdminUserListModelWithTeamsState {
    readonly adminUsersWithTeams: AdminUserListModelWithTeams[];
}

export type AppState = AdminUserListModelWithTeamsState & { router: Location };
